/**
 * 🧮 CALCULATION EXTRACTOR (Robust Mapping)
 */
export default function extractCalculations(rows, indexMap) {
  const calculations = [];
  const stack = [];

  const getIdx = (target) => {
    const key = Object.keys(indexMap).find(k => k.toLowerCase().trim() === target.toLowerCase().trim());
    return indexMap[key];
  };

  const L_IDX = getIdx("Level");
  const T_IDX = getIdx("Technical Name");
  const W_IDX = getIdx("Weight");

  if (L_IDX === undefined || T_IDX === undefined) return [];

  for (let i = 1; i < rows.length; i++) {
    const r = rows[i];
    const id = r[T_IDX];
    const level = parseInt(r[L_IDX]);
    const weight = parseFloat(r[W_IDX]) || 1;

    if (!id || isNaN(level)) continue;

    const node = { id, weight };
    if (level === 1) {
      stack[0] = node;
    } else {
      const parentNode = stack[level - 2];
      if (parentNode) {
        calculations.push({ parent: parentNode.id, child: id, weight: node.weight });
      }
      stack[level - 1] = node;
    }
  }
  return calculations;
}